import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Détection automatique de ws:// ou wss:// selon HTTPS
const wsProtocol = window.location.protocol === "https:" ? "wss" : "ws";
const ws = new WebSocket(`${wsProtocol}://unfriend.ca/ws/`);

ws.addEventListener("open", () => {
    console.log("✅ WebSocket connecté !");
});

ws.addEventListener("error", (err) => {
    console.error("❌ Erreur WebSocket : ", err);
});

ws.addEventListener("close", () => {
    console.warn("⚠️ WebSocket déconnecté. Tentative de reconnexion...");
    setTimeout(() => {
        window.location.reload(); // Recharge la page après 5 sec si WebSocket coupé
    }, 5000);
});

root.render(
  <React.StrictMode>
    <App ws={ws} />
  </React.StrictMode>
);

// Mesure des performances
reportWebVitals();
